
import CbFormText from "@/components/layouts/content-blocks/forms/CbFormText.vue";
import {PageDetailModeEnum} from "@/models/enum/PageDetailModeEnum";

export default {
  computed: {
    PageDetailModeEnum() {
      return PageDetailModeEnum
    }
  },
  components: {CbFormText}
}
